import { FieldState } from 'src/Types';
import { useLocalization, useSelectedOrdersRows } from 'src/Hooks';
import { useSelector } from 'react-redux';
import { globalSelectors } from 'src/Redux/Global/selectors';
import { useMemo } from 'react';
import { localizationUtils } from 'src/Utils/localizationUtils';
import { orderUtils } from '@/Utils/models/Order';

export const useOrderNumberTooltipMessage = (): FieldState => {
  const {
    models: {
      OrderTableRow: { OrderNumber, parts, CommonErrors },
    },
  } = useLocalization();

  const { orderRows, isPurchasesPage } = useSelectedOrdersRows();
  const localization = useSelector(globalSelectors.localization);

  return useMemo(() => {
    const result = orderRows.reduce(
      (res, current) => {
        if (current.orderNumberCreatedTime) {
          res.withOrderNumbers.add(current.orderNumber ?? '');
        }

        if (orderUtils.isOrderIsAmazonPending(current)) {
          res.amazonInProcessOrders.add(current.userOrderId.toString());
        }

        return res;
      },
      {
        withOrderNumbers: new Set<string>(),
        amazonInProcessOrders: new Set<string>(),
      },
    );

    const withOrderNumbers = [...result.withOrderNumbers];
    const amazonInProcessOrders = [...result.amazonInProcessOrders];

    let disabledDocumentMessage: string | undefined;
    const isIconDisabled = Boolean(withOrderNumbers.length || amazonInProcessOrders.length);

    if (withOrderNumbers.length) {
      disabledDocumentMessage = localizationUtils.insertTranslatedParamsToString(
        OrderNumber.DisableHeaderDocumentMessage,
        [withOrderNumbers.join(', '), withOrderNumbers.length],
        parts,
        localization,
      );
    } else if (amazonInProcessOrders.length) {
      disabledDocumentMessage = CommonErrors.AmazonOrderPending.DisableHeaderDocumentMessage;
    } // if

    return {
      value: '',
      isDocumentIconDisabled: isIconDisabled || isPurchasesPage,
      disabledDocumentMessage,
    };
  }, [localization, orderRows, isPurchasesPage]);
};
